import React from 'react';
import CTA from "../../../../components/Constant/cta/CTA";
import WhySection from "../../../../components/WhySection/WhySection";
import IntroSection from "../../../../components/IntroSection/IntroSection";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../../components/InfoBlocks/InfoBlocks";
import {Helmet} from "react-helmet";
import ServiceCards from "../../../../components/ServiceCards/ServiceCards";

export default function GamingLicenseGhana() {

    return (
        <main className='main'>
            <Helmet>
                <title>Ghana Gaming License | Secure iGaming License & Setup</title>
                <meta name="description" content="Apply for a Ghana gaming license with expert support. Fast, compliant setup for sportsbooks, casinos, and betting platforms." />
                <meta name="keywords" content="
                Ghana gaming license, sports betting license Ghana, online casino license Ghana, iGaming license Africa, betting license Ghana, gaming license Ghana cost, offshore gaming license Africa, online betting license Ghana, casino license Africa, gaming company formation Ghana, iGaming startup Africa, gaming compliance Ghana, Ghana Gaming Commission license, lottery license Ghana, gaming business setup Ghana, African gaming market, sportsbook license Africa, gaming operator license Ghana, regulated gaming Africa, betting company license
                "
                />
            </Helmet>

            <IntroSection
                title="Ghana Gaming License | Offshore Advisory"
                description=
                    {
                        `
                    Professional gaming license solutions in Ghana provide a trusted and regulated pathway for launching and operating online and land-based gaming businesses. Offshore Advisory supports entrepreneurs, gaming operators, and international investors in securing a Ghana gaming license with full compliance and efficiency.
                    <br/>
                    With a well-established regulatory authority, a growing gaming market, and strong legal oversight, Ghana is an attractive destination for online casinos, sportsbooks, and betting platforms targeting African markets. Our team ensures a smooth licensing process from consultation to ongoing compliance.
                    `
                    }
                buttonText="Request a Ghana Gaming Proposal →"
                buttonLink="/quote"
                imageSrc={require('../../../../assets/images/Ghana Gaming License 1.jpg')}
                imageAlt="Panama Gaming License"
            />


            <section className='section'>
                <div className="container">

                    <DetailsSection
                        title="Why Choose Ghana for a Gaming License?"
                        items={[
                            {
                                title: "Regulated Market",
                                text: "Operate under a recognized authority with clear legal frameworks."
                            },
                            {
                                title: "Growing Industry",
                                text: "Rapid expansion of sports betting and online gaming in Africa."
                            },
                            {
                                title: "Market Access",
                                text: "Strong presence in West Africa with increasing digital adoption."
                            },
                            {
                                title: "Credibility & Trust",
                                text: "Licensed operators gain higher player confidence."
                            },
                            {
                                title: "Local & International Opportunities",
                                text: "Ideal for both domestic and cross-border operations."
                            }
                        ]}
                    />

                    <h1 className='page-title'>
                        Our Services & Step-by-Step Licensing Process
                    </h1>
                    <p className='page-paragraph'>
                        At Offshore Advisory, we provide complete support to help you secure and operate under a Ghana gaming license. From initial consultation to post-license compliance, we simplify every stage.
                    </p>

                    <WhySection
                        title='1. Consultation & Business Planning'
                        subtitle='We begin by understanding your gaming business model and objectives. What we do:'
                        blocks={[
                            {
                                items: [
                                    {
                                        text: "Assess your gaming platform (sportsbook, casino, lottery, etc.)"
                                    },
                                    {
                                        text: "Advise on licensing requirements and structure"
                                    },
                                     {
                                        text: "Outline timelines, costs, and regulatory expectations"
                                    },

                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title='2. Company Formation & Local Requirements'
                        subtitle='To qualify for licensing, we ensure your business meets local requirements. Our support includes:'
                        blocks={[
                            {
                                items: [
                                    {
                                        text: "Company incorporation in Ghana"
                                    },
                                    {
                                        text: "Assistance with local director/shareholder requirements (if applicable)"
                                    },
                                    {
                                        text: "Structuring your company for compliance and efficiency"
                                    },

                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title='3. License Application & Documentation'
                        subtitle='We manage the full application process with regulatory authorities. Our services cover:'
                        blocks={[
                            {
                                items: [
                                    {
                                        text: "Preparation and submission of license applications"
                                    },
                                    {
                                        text: "Drafting policies (AML, KYC, Responsible Gaming)"
                                    },
                                    {
                                        text: "Ensuring full compliance with Ghanaian regulations"
                                    },

                                ]
                            }
                        ]}
                    />
                    <WhySection
                        title='4. Payment Integration & Platform Setup'
                        subtitle='We help you become fully operational in the market.'
                        blocks={[
                            {
                                items: [
                                    {
                                        text: "Integration with local payment solutions (mobile money, banks)"
                                    },
                                    {
                                        text: "Guidance on gaming software providers"
                                    },
                                    {
                                        text: "Support with platform deployment and hosting"
                                    },

                                ]
                            }
                        ]}
                    />
                    <WhySection
                        title='5. Ongoing Compliance & Regulatory Support'
                        subtitle='After licensing, we ensure your operations remain compliant.'
                        blocks={[
                            {
                                items: [
                                    {
                                        text: "Ongoing regulatory and reporting support"
                                    },
                                    {
                                        text: "Assistance with renewals and updates"
                                    },
                                    {
                                        text: "Advisory on international operational requirements"
                                    },

                                ]
                            }
                        ]}
                    />


                    <InfoBlocks
                        blocks={[
                            {
                                title: "Why This Approach Matters",
                                subtitle: "By combining expert advisory with a clear step-by-step process, Offshore Advisory ensures your Ghana gaming license is:",
                                items: [
                                    {
                                        title: "Efficient",
                                        text: "Streamlined application and approval process"
                                    },
                                    {
                                        title: "Compliant ",
                                        text: "Fully aligned with Ghana Gaming Commission regulations"
                                    },
                                    {
                                        title: "Transparent",
                                        text: "Clear costs and timelines from the start"
                                    },
                                    {
                                        title: "Growth-Ready",
                                        text: "Positioned for expansion within Africa"
                                    }
                                ]
                            },

                        ]}
                    />


                    <InfoBlocks
                        blocks={[
                            {
                                title: "Types of Gaming Licenses in Ghana",
                                items: [
                                    {
                                        title: "Sports Betting License",
                                        text: "For retail and online sports betting operations"
                                    },
                                    {
                                        title: "Online Casino License",
                                        text: "Operate digital casino platforms"
                                    },
                                    {
                                        title: "Lottery License",
                                        text: "Manage lottery and raffle systems"
                                    },
                                    {
                                        title: "Land-Based Gaming License",
                                        text: "For physical gaming shops and centers"
                                    }
                                ]
                            }
                        ]}
                    />

                    <ServiceCards
                        title='Who Can Benefit?'
                        services={
                            [
                                {
                                    title: "Entrepreneurs & Startups",
                                    text: "Enter the fast-growing African gaming market"
                                },
                                {
                                    title: "Gaming Operators",
                                    text: "Expand into Ghana and West Africa",
                                },
                                {
                                    title: "International Investors",
                                    text: "Tap into emerging market opportunities",
                                },
                                {
                                    title: "Tech & Fintech Companies",
                                    text: "Integrate gaming into digital platforms",
                                },
                            ]
                        }
                        end="Operating under a Ghana gaming license positions your business in one of Africa’s most promising and regulated gaming markets."
                    />


                    <Testimonials
                        title="Our Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <FAQList data={faqData} title='FAQs – Ghana Gaming License'/>

                    <CTA
                        title="Contact Offshore Advisory Today!"
                        description="Ready to launch your gaming business in Ghana? Offshore Advisory ensures a smooth, compliant, and efficient licensing process."
                        buttonText="Book a Tuvalu Gaming License Consultation →"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Can foreign investors apply for a Ghana gaming license?",
        answer: "Yes, foreign investors can apply, subject to local incorporation and regulatory requirements."
    },
    {
        question: "How long does the licensing process take?",
        answer: "Typically 4–8 weeks depending on documentation and approvals."
    },
    {
        question: "Do I need a local company in Ghana?",
        answer: "Yes, a locally registered entity is generally required."
    },
    {
        question: "What are the costs involved?",
        answer: "Costs vary based on license type and scale of operations, with full transparency provided upfront."
    },
    {
        question: "What payments can I accept in Ghana?",
        answer: "Operators commonly use mobile money, bank transfers, and card payments."
    },
];

const testimonialsData = [
    {
        quote: "Offshore Advisory guided us through Ghana’s licensing process with professionalism and clarity. We launched without delays.",
        author: "Michael T.",
        role: "Betting Operator"
    },
    {
        quote: "Their team handled everything from company setup to compliance. Highly recommended for entering African markets.",
        author: "Anita K.",
        role: "Gaming Entrepreneur"
    },

];

